<div class="wrapper">
    <div class="m-box">
        <h2>Cancelled Appointments Search</h2>
        <div class="margin-div">
            From  <input [matDatepicker]="startDatepicker"  [(ngModel)]="startDate" (ngModelChange)="onStartDateChange($event)"   class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()">
            <mat-datepicker #startDatepicker></mat-datepicker>
            Until
            <input [matDatepicker]="endDatepicker"  [(ngModel)]="endDate" (click)="endDatepicker.open()" (ngModelChange)="onEndDateChange($event)" class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP">
            <mat-datepicker #endDatepicker></mat-datepicker>
            <button class="orange-btn" matTooltip="Search Exams"   matTooltipPosition="after" (click)="search()" >Search</button>
           </div>
           <div  class="search-results">
            <table *ngIf="deletedAppointments && deletedAppointments.length">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Appointment</th>
                    <th>Date</th>
                    <th>Patient Name</th>
                    <th>Patient ID</th>
                    <th>Doctor</th>
                    <th><img
                        style="cursor: pointer"
                        matTooltip="Download CVS"
                        (click)="exportExcel()"
                       height="31em"
                        width="31em"
                        src="../../assets/icons/fileblue.svg"
                          /></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appointment of deletedAppointments| sortByDateTime; let i = index">
                    <td>{{i + 1}} </td>
                    <td>{{ appointment.examName }}</td>
                    <td>{{ appointment.aptTime | date:"dd.MM.yyyy HH:mm"}}</td>
                    <td>{{ appointment.First }} {{ appointment.Last }}</td>
                    <td>{{ appointment.ID }}</td>
                    <td>{{ appointment.Name }}</td>
                  </tr>
                </tbody>
              </table>
         </div>
    </div>
</div>
